var boostPFSInstantSearchConfig={search:{}};!function(){BoostPFS.inject(this),SearchInput.prototype.customizeInstantSearch=function(){}}();
//# sourceMappingURL=/s/files/1/2471/4446/t/189/assets/boost-pfs-instant-search.js.map?v=1633459894
